export enum TypePersonneEnum {
    DEMANDEUR = 'DEMANDEUR',
    CONJOINT = 'CONJOINT',
    ENFANT = 'ENFANT'    
}
